import React, { useState, useEffect } from 'react';
import {
  Container, Row, Col, ListGroup, Breadcrumb,
} from 'react-bootstrap';

import Footer from '../../components/Footer';
import NavBar from '../../components/NavBars';
import api from '../../services/api';

export default function Comissoes() {
  const [commissions, setCommissions] = useState([]);

  useEffect(() => {
    try {
      (async () => {
        const { data } = await api.get('commissions');
        setCommissions(data);
      })();
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <>
      <NavBar />
      <Container className="justify-content-md-center mb-5" fluid="md">
        <Row>
          <Col className="mt-3">
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item active>Comissões</Breadcrumb.Item>
            </Breadcrumb>
          </Col>
        </Row>
        <Row>
          <Col className="bg-white mt-1">
            <h1>Comissões</h1>
          </Col>
        </Row>
        <Row>
          <Col md={4} className="mt-3 bg-light">
            <ListGroup variant="flush">
              <ListGroup.Item
                className="bg-light text-dark"
                variant="dark"
                action
                href="#"
                active
              >
                Comissões
              </ListGroup.Item>
            </ListGroup>
          </Col>
          <Col className="mt-3 bg-white">
            <Container className="mt-3">
              {commissions.map((c) => (
                <Row className="border p-2 mb-2">
                  <h6>{c.name}</h6>
                </Row>
              ))}
            </Container>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}
